import { readCookieConsent } from '@/utils/cookie';
import { GTM_ID } from '@/utils/gtm';

/*
 * Basic consent mode: the container is not injected on boot (see the gtm block
 * in nuxt.config.js), so a returning visitor who already accepted needs it
 * loaded here. Someone who declined, or who has not answered, gets nothing -
 * not even a cookieless ping.
 *
 * The banner handles the other direction, calling $gtm.init itself so accepting
 * takes effect without a reload.
 *
 * $gtm comes from the module's own plugin, and plugin order is not something
 * this file should depend on: if it has not been injected yet we wait for
 * onNuxtReady, which fires once every plugin has run. If it never appears the
 * container simply is not loaded - worse for analytics, harmless for the
 * visitor, and better than throwing on boot.
 */
export default function (context) {
  const consent = readCookieConsent();

  if (!consent || !consent.hasConsent) {
    return;
  }

  // Resolved the same way in both places: checking context.$gtm to decide but
  // context.app.$gtm to act would skip the immediate path for an injection that
  // only lands on app, and rely on onNuxtReady to save it.
  const resolveGtm = () => context.$gtm || (context.app && context.app.$gtm);

  const initGtm = () => {
    const gtm = resolveGtm();

    if (gtm) {
      gtm.init(GTM_ID);
    }
  };

  if (resolveGtm()) {
    initGtm();
  } else if (typeof window !== 'undefined' && typeof window.onNuxtReady === 'function') {
    window.onNuxtReady(initGtm);
  }
}
